import request from '@/plugins/request'
export const listRecords = (pageNum,pageSize,data) => {
  return request({
    url: `/crm/records/list/${pageNum}/${pageSize}`,
    method: 'POST',
    data
  })
}
export const listFunnels = (pageNum,pageSize,data) => {
  return request({
    url: `/crm/salesFunnel/listAll/${pageNum}/${pageSize}`,
    method: 'POST',
    data
  })
}
export const findConpany = (current,size,keyWork) => {
  return request({
    url: `/crm/getCorporateInformation?current=${current}&size=${size}&keyWork=${keyWork}`,
    method: 'get',
  })
}
export const findThisConpany = (keyWork) => {
  return request({
    url: `/crm/getBaseinfo?keyWork=${keyWork}`,
    method: 'get',
  })
}
export const baseAdd = (data) => {
  return request({
    url: `/crm/records/Baseadd`,
    method: 'post',
    data
  })
}
export const ReAdd = (data) => {
  return request({
    url: `/crm/records/add`,
    method: 'post',
    data
  })
}
export const updateRe = (data) => {
  return request({
    url: `/crm/records/update`,
    method: 'post',
    data
  })
}
export const SaUFunnel = (data) => {
  return request({
    url: `/crm/salesFunnel/saveAndUpdate`,
    method: 'post',
    data
  })
}
export const savefollow = (data) => {
  return request({
    url: `/crm/followRecord/save`,
    method: 'post',
    data
  })
}
export const ChaChong = (data) => {
  return request({
    url: `/crm/records/chachong`,
    method: 'post',
    data
  })
}
export const selectThisRecord = (id) => {
  return request({
    url: `/crm/records/detail/${id}`,
    method: 'post',
  })
}
export const getFunnel = (id) => {
  return request({
    url: `/crm/salesFunnel/get/${id}`,
    method: 'post',
  })
}
export const getfamily = (id) => {
  return request({
    url: `/crm/records/family/${id}`,
    method: 'post',
  })
}
export const getfollow = (id) => {
  return request({
    url: `/crm/followRecord/get/${id}`,
    method: 'post',
  })
}
export const getUserId = () => {
  return request({
    url: `/crm/getUserId`,
    method: 'get',
  })
}
export const exportExcel = (data) => {
  return request({
    url: `/crm/exportExcel`,
    method: 'post',
    data,
    responseType:'blob'
  })
}
export const getMaxId = (data) => {
  return request({
    url: `/crm/getMaxId`,
    method: 'post',
    data,
  })
}
export const getAllSale = (data) => {
  return request({
    url: `/crm/getAllSale`,
    method: 'post',
    data,
  })
}
export const listSalemen = () => {
  return request({
    url: `/crm/salemen/list`,
    method: 'post',
  })
}
export const addSalemen = (data) => {
  return request({
    url: `/crm/salemen/add`,
    method: 'post',
    data,
  })
}
export const calcRate = (data) => {
  return request({
    url: `/crm/calcRate`,
    method: 'post',
    data,
  })
}
